import { Injectable } from '@angular/core';
import { AbstractControl, FormGroup, ValidationErrors } from '@angular/forms';

const pattern_messages = {
  '/^[a-zA-Z]*$/': 'Only alphabets allowed',
  '^(?!-)[A-Za-z0-9-]+([a-z0-9]+)(?<!-)$':
    'Should start with a letter and only consist of letters, digits and hyphens with 4-20 characters',
  '^[A-Za-z0-9]+(?:-[A-Za-z0-9]+)*[a-z0-9]+$':
    'Should start with a letter and only consist of letters, digits and hyphens with 4-20 characters',
};

@Injectable({
  providedIn: 'root',
})
export class FormErrorsService {
  constructor() {}

  getErrorMsg(control: AbstractControl | null, field = ''): string | null {
    field = field.replace('_', ' ');
    if (control == null || control.touched == false) {
      return null;
    }
    const errors: any = control?.errors;
    if (errors) {
      // return this.toMsg(errors, field, control.value)
      if (errors?.required) {
        return `This ${field} is required`;
      }

      if (errors?.min) {
        return 'Minimum for this field is ' + errors?.min?.requiredLength;
      }

      if (errors?.max) {
        return 'Minimum for this field is ' + errors?.max?.requiredLength;
      }

      if (errors?.minlength) {
        return 'Minimum length for this field is ' + errors?.minlength?.requiredLength;
      }

      if (errors?.email) {
        return 'Invalid email format';
      }

      if (errors?.matching) {
        return `${field} did not matched`;
      }

      if (errors?.pattern) {
        const pattern: string = errors.pattern.requiredPattern;
        if (pattern_messages[pattern as keyof typeof pattern_messages]) {
          return pattern_messages[pattern as keyof typeof pattern_messages];
        } else if (pattern == '/^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{6,}$/') {
          const hasNumber = /[0-9]/;
          const hasSpecial = /[!@#$%^&*]/;
          if (!hasNumber.test(control.value)) {
            return 'Password mast have at least one number';
          }
          if (!hasSpecial.test(control.value)) {
            return 'Password mast have at least one special character';
          }
        }
        return 'Invalid format';
      }
      if (errors?.inuse) {
        return `${field} already in use`;
      }
      if (errors?.raw) {
        return errors?.raw;
      }
      if (errors?.server) {
        return errors.server; // Handle custom server-side errors
      }
    }

    return null;
  }

  toMsg(errors: any, field = '', value = '') {
    // if(errors?.required) {
    //     return 'this field is required';
    // }

    if (errors?.minlength) {
      return 'minimum length for this field is ' + errors?.minlength?.requiredLength;
    }

    if (errors?.email) {
      return 'invalid email format';
    }

    if (errors?.matching) {
      return `${field} did not matched`;
    }

    if (errors?.pattern) {
      const pattern: string = errors.pattern.requiredPattern;
      if (pattern_messages[pattern as keyof typeof pattern_messages]) {
        return pattern_messages[pattern as keyof typeof pattern_messages];
      } else if (pattern == '/^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{6,}$/') {
        const hasNumber = /[0-9]/;
        const hasSpecial = /[!@#$%^&*]/;
        if (!hasNumber.test(value)) {
          return `${field} mast have atleast one number`;
        }
        if (!hasSpecial.test(value)) {
          return `${field} mast have atleast one special character`;
        }
      }
      return 'invalid format';
    }

    if (errors?.inuse) {
      return `${field} already in use`;
    }

    if (errors?.raw) {
      return errors?.raw;
    }

    return null;
  }

  getErrorText(control: AbstractControl | null): string | null {
    if (control?.touched && control?.invalid) {
      if (control.errors?.['required']) {
        return 'This field is required.';
      } else if (control.errors?.['minlength']) {
        return `Minimum length should be ${control.errors['minlength'].requiredLength}.`;
      } else if (control.errors?.['maxlength']) {
        return `Maximum length should be ${control.errors['maxlength'].requiredLength}.`;
      } else if (control.errors?.['email']) {
        return 'Invalid email address.';
      } else if (control.errors?.['pattern']) {
        return 'Invalid input format.';
      } else if (control.errors?.['inuse']) {
        return 'This value is already in use.';
      } else if (control.errors?.['server']) {
        return control.errors['server']; // Handle custom server-side errors
      }
    }
    return null;
  }

  getFormValidationErrors(form: FormGroup) {
    const result: any[] = [];
    Object.keys(form.controls).forEach(key => {
      const formProperty = form.get(key);
      if (formProperty instanceof FormGroup) {
        result.push(...this.getFormValidationErrors(formProperty));
      }
      const controlErrors: ValidationErrors | null | undefined = formProperty?.errors;
      if (controlErrors) {
        Object.keys(controlErrors).forEach(keyError => {
          result.push({
            control: key,
            error: keyError,
            value: controlErrors[keyError],
          });
        });
      }
    });

    return result;
  }
}
